// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2OTrk","footer":"ChangeClinic_footer__EE46m"};